import { render, staticRenderFns } from "./AvatarSelector.vue?vue&type=template&id=ea61e8f4&scoped=true&"
import script from "./AvatarSelector.vue?vue&type=script&lang=js&"
export * from "./AvatarSelector.vue?vue&type=script&lang=js&"
import style0 from "./AvatarSelector.vue?vue&type=style&index=0&id=ea61e8f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea61e8f4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VRow})
